import { render, staticRenderFns } from "./homebody.vue?vue&type=template&id=04b0bfdf&"
import script from "./homebody.vue?vue&type=script&lang=js&"
export * from "./homebody.vue?vue&type=script&lang=js&"
import style0 from "./homebody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports